/* Reducer to control actions and values set by the SubHeader component */
const actionTypes = {
  SetGlobalValue: 'subheader/SET_GLOBAL_VALUE',
}

const initialState = {
  showEventSettingsModal: false,
  dimissedEventSettingsBanners: [],
  showGdapMagicLinkModal: false,
  redirectNav: null,
  redirectedFromLogin: false,
  createNewPolicy: false,
  openImportTenantBaselineModal: false,
  createNewAuthenticationMethod: false,
  createNewRiskyIp: false,
  createNewRiskyCountry: false,
  createNewNamedLocationFromTemplate: false,
  openCreateTeamsPolicyBaseline: false,
  openCreateTeamsPolicyTemplate: false,
  openCreateTeamsSettingsTemplate: false,
  openCreateTeamsAppSetupPolicyBaseline: false,
  openCreateTeamsAppSetupPolicyTemplate: false,
  openCreateTeamsChannelsPolicyBaseline: false,
  openCreateTeamsChannelsPolicyTemplate: false,
  openCreateTeamsExternalAccessPolicyBaseline: false,
  openCreateTeamsExternalAccessPolicyTemplate: false,
  openCreateTeamsMeetingPolicyBaseline: false,
  openCreateTeamsMeetingPolicyTemplate: false,
  openCreateTeamsMessagingPolicyBaseline: false,
  openCreateTeamsMessagingPolicyTemplate: false,
  openDeployTeamsPolicyBaseline: false,
  openDeployTeamsPolicyTemplate: false,
  openCreateTeamsPolicy: false,
  openEditTeamsSettingsModal: false,
  openEditSharePointSettingsModal: false,
  openCreateSharePointSettingsTemplate: false,
  openCreateSharePointBaseline: false,
  showEngageDefaultSettings: false,
  activateChat: false,
  delegatedChatPayload: null,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetGlobalValue:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export const actions = {
  setGlobalValue: (payload = {}) => ({
    type: actionTypes.SetGlobalValue,
    payload,
  }),
}
